import React, { FunctionComponent, SVGProps } from 'react';

type SVGRProps = {
  alt?: string;
};

export const BrainLeftIcon: FunctionComponent<SVGProps<SVGSVGElement> & SVGRProps> = (props) => (
  <svg
    width={25}
    height={50}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 250 500"
    {...props}
  >
    <path
      // eslint-disable-next-line max-len
      d="M-.2 243.263A242.699 242.699 0 0 0 71 414.942a242.78 242.78 0 0 0 78.826 52.593 242.827 242.827 0 0 0 92.959 18.415V.475A242.827 242.827 0 0 0 149.802 18.9 242.79 242.79 0 0 0 70.964 71.52a242.736 242.736 0 0 0-52.678 78.791A242.697 242.697 0 0 0-.199 243.263Z"
      fill="#000"
    />
  </svg>
);
